<template>
  <div class="disability-page">
    <div class="disability-inner">

      <!-- WebP 224 KB，不支援的瀏覽器自動退回 PNG 378 KB -->
      <picture>
        <source :srcset="posterWebp" type="image/webp" />
        <img
          class="poster"
          :src="posterPng"
          width="1254"
          height="1254"
          alt="身障優惠請先登記：完成登記即可享有每日停車優惠 6 小時。只需填寫基本資料即可完成登記，符合資格即享優惠，個人資料將妥善保護。可掃描 QR Code 或點下方按鈕前往登記。"
        />
      </picture>

      <!-- 手機使用者無法掃描自己螢幕上的 QR Code，這顆按鈕才是他們的入口 -->
      <a
        class="register-button"
        href="https://webrent.taiwan-parking.com.tw/WebRentcs_3571/WebRentcs.aspx"
        target="_blank"
        rel="noopener noreferrer"
      >
        前往身障優惠登記
      </a>

      <p class="register-note">將於新視窗開啟登記頁面</p>

    </div>
  </div>
</template>

<script>
// 明確 import 讓 webpack 處理雜湊檔名；srcset 綁定需要真實 URL
import posterWebp from '@/assets/disability-parking-register.webp';
import posterPng from '@/assets/disability-parking-register.png';

export default {
  name: 'DisabilityParkingPage',
  data() {
    return {
      posterWebp,
      posterPng,
    };
  },
};
</script>

<style scoped>
.disability-page {
  width: 100%;
  background-color: #f5f5f5;
  padding: 32px 16px 64px;
  box-sizing: border-box;
}

.disability-inner {
  max-width: 620px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.poster {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}

/* picture 為 inline 元素，需撐滿容器寬度 */
.disability-inner picture {
  display: block;
  width: 100%;
}

.register-button {
  margin-top: 26px;
  width: 100%;
  max-width: 420px;
  box-sizing: border-box;
  padding: 16px 24px;
  border-radius: 10px;
  background-color: #0f6e8c;
  color: #ffffff;
  font-size: 19px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0.02em;
  transition: background-color 0.2s ease;
}

.register-button:hover {
  background-color: #0c5a73;
}

.register-button:focus-visible {
  outline: 3px solid #f2c200;
  outline-offset: 3px;
}

.register-note {
  margin: 12px 0 0;
  font-size: 13px;
  color: #6b7885;
}

@media screen and (max-width: 560px) {
  .disability-page {
    padding: 20px 12px 48px;
  }

  .register-button {
    font-size: 17px;
    padding: 15px 20px;
  }
}
</style>
